export default class PrinterService {

    printerMap = {};
    constructor() {
      if (PrinterService.instance) {
        return PrinterService.instance;
      }
      PrinterService.instance = this;
    }
  
    getPrinter (item) {
      return this.printerMap[item] || {}
    }
  
    setItemsPrinter(items) {
       this.printerMap = { 
            ...this.printerMap,
            ...items
       }

    }
  }
  

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { PrinterService };
